import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import ProjectPage from '../../components/ProjectPage'

const projectElements = {
	images: [
	  {
	    "src": "Schreibtherapie/past_1",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Schreibtherapie/past_2",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Schreibtherapie/past_3",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Schreibtherapie/past_4",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Schreibtherapie/past_5",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Schreibtherapie/past_6",
	    "orientation": "landscape"
	  }
	]
}

export default class Schreibtherapie extends React.Component{
	render(){
		return(
			<ProjectPage 
			title="Schreibtherapie" 
			text={`Schreibtherapie ist kein Projekt, bei welchem es grundsätzlich darum geht schöne Bilder zu präsentieren. Viel eher will ich mit diesem Projekt ausdrücken, wie wichtig es ist auf sich selbst zu achten. 

Die Bilder zeigen eine fotografische Umsetzung meiner Journal-Einträge, welche vor, während und nach meiner Psychotherapie entstanden sind. In der Therapie habe ich es geschafft mich selbst wieder zu verstehen und gelernt wie ich meine Ängste zügeln kann. Dank den vielen Stunden, die ich auf dieser schwarzen Ledercouch verbracht habe, kann ich mich selbst und meine Zukunft selbstsicher und glücklich entdecken. Dabei hat mir vor allem auch das Schreiben geholfen. Es geht hier nicht um ein Tagebuch in welches man jeden Tag hineinschreibt und erzählt wie schön das Wetter nicht war. Es geht vielmehr darum, die eigenen inneren Erlebnisse und Gefühle niederzuschreiben. 

Schon länger wollte ich dieses Projekt verwirklichen, um mit dieser Vergangenheit auch auf kreativem Wege abzuschließen und um zu zeigen, dass man sich für seine Schwächen nicht schämen muss und das Gute am Ende immer gewinnt.`}
			images={projectElements.images}
			layout={'einser'}/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/projects/past.js